import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {MatToolbarModule} from '@angular/material/toolbar';
import { MyFileDropComponent } from './my-file-drop/my-file-drop.component';
import {MatTableModule} from '@angular/material/table';
import { ToolbarComponent } from './toolbar/toolbar.component';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatDialogModule} from '@angular/material/dialog';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import {MatExpansionModule} from '@angular/material/expansion';
import { LogdetailComponent } from './logdetail/logdetail.component';

@NgModule({
   declarations: [
      AppComponent,
      MyFileDropComponent,
      ToolbarComponent,
      LogdetailComponent
   ],
   imports: [
      BrowserModule,
      AppRoutingModule,
      BrowserAnimationsModule,
      MatToolbarModule,
      MatTableModule,
      MatInputModule,
      MatButtonModule,
      MatCardModule,
      MatDialogModule,
      FormsModule,
      NgbModule,
      MatExpansionModule
   ],
   providers: [],
   bootstrap: [
      AppComponent
   ]
})
export class AppModule { }
